import { render, staticRenderFns } from "./Prescribing.vue?vue&type=template&id=422aa5cc&"
import script from "./Prescribing.vue?vue&type=script&lang=js&"
export * from "./Prescribing.vue?vue&type=script&lang=js&"
import style0 from "./Prescribing.vue?vue&type=style&index=0&id=422aa5cc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports